{
    "sites": [
        {
            "id": 1,
            "name": "Be Live",
            "prod": "https://babylon.com",
            "staging": "https://babylon-staging.clicktotravel.es/es/",
            "dev": "https://babylon-dev.clicktotravel.es/",
            "file": "site1.json"
        }
    ]
}
